import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { IconButton, Tooltip, useTheme } from '@mui/material';

export const TitleButton = ({ disabled, icon, color, toolTip, onClick, children }) => {
  const theme = useTheme();

  const iconColor = disabled ? theme.palette.action.disabled : (color ?? theme.palette.text.primary);

  return (
    <Tooltip title={toolTip}>
      <IconButton
        component={children ? 'label' : null} // If children are passed to TitleButton, it is assumed to be a hidden file input
        size="large"
        disabled={disabled}
        onClick={onClick}
      >
        {children}
        <FontAwesomeIcon icon={icon} color={iconColor} />
      </IconButton>
    </Tooltip>
  );
};
